import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
const Columns = ( getReports ) => {
	//headers: (type === 'excel') ? header_excel : header_pdf
		let columns = [
			{
				id: 'number',
				name: 'Unidad',
				selector: row => row.number,
				sortable: true,
				wrap: true,
			},
			{
				id: 'type',
				name: 'Tipo',
				selector: row => row.type,
				sortable: true,
				wrap: true,
			},
			
			{
				id: 'owner',
				name: 'Propietario',
				selector: row => row.owner,
				sortable: true,
				wrap: true,
			},
			{
				id: 'actions',
				name: 'Acciones',
				width:'35%',
				button: true,
				cell: row => (
					<div className="d-flex justify-content-between">
						<div className="p-2">
                            <button className="btn btn-primary btn-sm" title='Imprimir' onClick={() => getReports(row.id,1)}>
                            	<i className="fa fa-print"></i> Imprimir
                            </button>
                        </div>
                        <div className="p-2">
                            <button className="btn btn-primary btn-sm" title='Imprimir Vertical' onClick={() => getReports(row.id,2)}>
                            	<i className="fa fa-print"></i> Imprimir vertical
                            </button>
                        </div>
                        <div className="p-2">
	                        <Link to={`#`} className="btn btn-info btn-sm" onClick={() => getReports(row.id,3)} title='Detalle de Salidas'>
	                            <i className="fa fa-eye"></i> Ver Papeleta
							</Link>
                        </div>

					</div>
				),
			}
			
		];
	return columns;
}

export default Columns;

//vaneton beicli